// extracted by mini-css-extract-plugin
export default {"divider":"DateDivider_divider__4ah4B","container":"DateDivider_container__Duq77"};